var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHourglassDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7673_33103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 4H16V7.5L13.16 10.34L14.41 11.59L18 8.01L17.99 8H18V2H6V3.17L8 5.17V4Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.09994 2.09961L0.689941 3.50961L9.58994 12.4096L5.99994 15.9996L6.00994 16.0096H5.99994V21.9996H17.9999V20.8296L20.4899 23.3196L21.8999 21.9096L2.09994 2.09961ZM15.9999 19.9996H7.99994V16.4996L10.8399 13.6596L15.9999 18.8296V19.9996Z",
    fill: "#D1D1D1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7673_33103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglassDisabled);
export default __webpack_public_path__ + "static/media/hourglass_disabled.bd5e59253d58f575b96227980fae78f3.svg";
export { ForwardRef as ReactComponent };